// extracted by mini-css-extract-plugin
export default {"inner":"StickyBar_inner__Q4Ts2","sticky":"StickyBar_sticky__gQyGo"};